import { Link } from 'react-router-dom';
import { caseStudies } from '@/mocks/caseStudies';

export default function CaseStudies() {
  return (
    <section id="cases" className="section-padding bg-background-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="mb-10 md:mb-14">
          <p className="text-primary-500 font-bold text-sm tracking-widest uppercase mb-2">
            BOŞ LAF DEĞİL
          </p>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl text-foreground-50 tracking-tighter">
            SONUÇLAR
          </h2>
          <p className="text-sm md:text-base text-foreground-400 mt-3 font-medium">
            Problem &rarr; Strateji &rarr; Sonuç
          </p>
        </div>

        {/* Cases Grid */}
        <div className="grid md:grid-cols-3 gap-5 md:gap-6">
          {caseStudies.map((study) => (
            <div
              key={study.id}
              className="glass-card-hover rounded-2xl p-6 md:p-8 group"
            >
              {/* Case badge */}
              <div
                className={`inline-block px-4 py-2 rounded-lg bg-gradient-to-r ${study.gradient} mb-6`}
              >
                <h3 className="text-lg md:text-xl font-bold text-foreground-50">
                  {study.title}
                </h3>
              </div>

              <div className="space-y-5">
                <div>
                  <h4 className="text-xs md:text-sm font-bold text-primary-500 mb-1 uppercase tracking-wider">
                    Problem
                  </h4>
                  <p className="text-sm md:text-base text-foreground-300 leading-relaxed">
                    {study.problem}
                  </p>
                </div>
                <div>
                  <h4 className="text-xs md:text-sm font-bold text-primary-500 mb-1 uppercase tracking-wider">
                    Strateji
                  </h4>
                  <p className="text-sm md:text-base text-foreground-300 leading-relaxed">
                    {study.strategy}
                  </p>
                </div>
                <div>
                  <h4 className="text-xs md:text-sm font-bold text-primary-500 mb-1 uppercase tracking-wider">
                    Sonuç
                  </h4>
                  <p className="text-sm md:text-base text-foreground-300 leading-relaxed">
                    {study.result}
                  </p>
                </div>
              </div>

              <Link
                to={`/basarili-dijital-projeler/${study.slug}`}
                className="inline-flex items-center gap-2 text-sm font-bold text-primary-500 hover:text-primary-600 transition-colors uppercase tracking-wider mt-6 cursor-pointer"
              >
                Vakayı İncele
                <i className="ri-arrow-right-line" />
              </Link>
            </div>
          ))}
        </div>

        {/* Link to full case studies page */}
        <div className="mt-10 text-center">
          <Link to="/basarili-dijital-projeler" className="inline-flex items-center gap-2 text-sm font-bold text-primary-500 hover:text-primary-600 transition-colors uppercase tracking-wider">
            Tüm Vakaları İncele
            <i className="ri-arrow-right-line" />
          </Link>
        </div>
      </div>
    </section>
  );
}